import { MuiBox, MuiTypography } from "../../../../../../../../../../components";
import { SalesCreditDetailsTableHeaderWrapper } from "./SalesCreditDetailsTableHeader.style";

export const SalesCreditDetailsTableHeader: React.FC<{
  header: string;
}> = ({ header }) => {
  return (
    <SalesCreditDetailsTableHeaderWrapper>
      <MuiBox className="sales-credit-header-semi-header">
        <MuiTypography variant="h2SemiBold">{header}</MuiTypography>
      </MuiBox>
    </SalesCreditDetailsTableHeaderWrapper>
  );
};
